import { FC } from 'react';
import EfSpec from '@elem/ui/ef-spec';
import styles from './index.module.scss';
import Frag from './Frag';
import { useLang } from '@/i18n';

type ItemType = {
    label?: string;
    title: string;
    desc?: string;
    youtube?: string;
    link?: string;
    img: {
        pc: string;
        h5: string;
    };
};

const F: FC = () => {
    const { t } = useLang('ces2025');
    const items: ItemType[] = [
        {
            label: t('F_item1_label'),
            title: t('F_item1_title'),
            desc: t('F_item1_desc'),
            // youtube: t('F_item1_url'),
            img: {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1734675226698/pc-ces-oasis.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1734675236912/m-ces-oasis.jpg',
            },
        },
        {
            label: t('F_item2_label'),
            title: t('F_item2_title'),
            desc: t('F_item2_desc'),
            link: t('F_item2_url'),
            img: {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1733383295389/whole%20home.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1733383295581/whole%20home%20(1).jpg',
            },
        },
        {
            label: t('F_item3_label'),
            title: t('F_item3_title'),
            desc: t('F_item3_desc'),
            link: t('F_item3_url'),
            img: {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1733383296611/RV.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1733383296428/RV%20(1).jpg',
            },
        },
        {
            label: t('F_item4_label'),
            title: t('F_item4_title'),
            desc: t('F_item4_desc'),
            link: t('F_item4_url'),
            img: {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1733383296200/Rapid.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1733383295985/Rapid%20(1).jpg',
            },
        },
    ];

    return (
        <section className={styles.section} id="CES-2025-F">
            <EfSpec />
            <p className="sec-title">{t('F_title')}</p>
            <ul className="items">
                {items.map((item: ItemType, k: number) => (
                    <li key={k} className="item">
                        <Frag {...item} />
                    </li>
                ))}
            </ul>
        </section>
    );
};

export default F;
